<div
  class="row overflow-hidden"
  (click)="openEmployeeInfoModal()"
>
  <div class="col-3 d-flex align-items-center">
    <base-checkbox
      *ngIf="!isWorkCouncil"
      [isChecked]="assignmentListItem.isSelected"
      (click)="onItemSelect($event)"
    ></base-checkbox>
    <div [ngClass]="{ 'ms-7': !isWorkCouncil }">
      <span
        baseTruncate
        class="fw-bold external-employee-name"
        >{{ profileFullName }}</span
      >
      <br />
      <span baseTruncate>{{ assignmentListItem.mainQualification.name | baseIsEmpty }}</span>
    </div>
  </div>

  <div class="col-2">
    <div class="d-flex align-items-center gap-3">
      <base-izs-rating
        *ngIf="!hasWorkCouncilRole"
        [color]="assignmentListItem.pspBranch.izsStatus"
        (click)="openIzsInfoModal($event)"
      ></base-izs-rating>
      <div class="d-flex flex-column">
        <span baseTruncate>{{ assignmentListItem.pspBranch.name | baseIsEmpty }}</span>
        <span baseTruncate>{{ assignmentListItem.pspBranch.businessAddress.city | baseIsEmpty }}</span>
      </div>
    </div>
  </div>

  <div class="col-3">
    <span baseTruncate>{{ assignmentListItem.customerDepartment.name | baseIsEmpty }}</span
    ><br />
    <span baseTruncate>{{ assignmentListItem.customerLocation.name | baseIsEmpty }}</span>
  </div>

  <div class="col-2">
    <span
      baseTruncate
      [ngClass]="{
        'operation-date-active': statuses.isActiveAssignment,
        'operation-date-planned': statuses.isPlannedAssignment,
        'operation-date-ended': statuses.isEndedAssignment
      }"
      class="fw-bold operation-date-planned"
      >{{ 'dateTime.startFrom' | translate }} {{ assignmentListItem.startDate | baseFormatDate | baseIsEmpty }}<br
    /></span>
    <span
      baseTruncate
      *ngIf="statuses.isActiveAssignment || statuses.isEndedAssignment"
      [ngClass]="{
        'operation-date-active': statuses.isActiveAssignment,
        'operation-date-ended': statuses.isEndedAssignment
      }"
      class="fw-bold"
      >{{ 'dateTime.to' | translate | lowercase }}
      <ng-container *ngIf="!assignmentListItem.unlimited; else unlimitedDate">
        {{ assignmentListItem.endDate | baseFormatDate | baseIsEmpty }}
      </ng-container>
      <ng-template #unlimitedDate>
        {{ assignmentListItem.endDate | baseFormatDate | baseIsEmpty }} ({{
          'inquiry.unlimitedUntilMLPShort' | translate
        }})
      </ng-template></span
    >
    <p
      *ngIf="assignmentListItem?.assignmentCancelation?.cancelationDate"
      baseTruncate
      class="fw-bold text-danger mb-0"
    >
      {{ 'operations.cancelledOn' | translate }}
      {{ assignmentListItem?.assignmentCancelation?.cancelationDate | baseFormatDate }}
    </p>
  </div>

  <div
    class="col-2 d-flex justify-content-end gap-2"
    *ngIf="!isWorkCouncil"
  >
    <base-sign-contract-animated-status-button
      *ngIf="
        assignmentListItem.contract.type === contractSigningType.DIGITAL &&
          (assignmentListItem.contract.signatures?.statusCustomer === signingStatusBySide.IN_QUEUE ||
            assignmentListItem.contract.signatures?.statusCustomer === signingStatusBySide.ERROR ||
            assignmentListItem.contract.signatures?.statusPsp === signingStatusBySide.ERROR);
        else standardButton
      "
      [contract]="assignmentListItem.contract"
      (click)="openSignContractsModal($event)"
    ></base-sign-contract-animated-status-button>
    <ng-template #standardButton>
      <base-button
        color="dark"
        icon="fa-solid fa-file-signature"
        [size]="buttonSizes.md"
        [iconSize]="buttonSizes.md"
        [stateClass]="statusButtonBorder"
        [ngbTooltip]="signStatusTooltip"
        [permissionBased]="true"
        (btnClick)="openSignContractsModal($event)"
      ></base-button>
    </ng-template>
    <base-button
      color="dark"
      icon="fa-solid fa-calendar-clock"
      [size]="buttonSizes.md"
      [iconSize]="buttonSizes.md"
      tooltip="externalEmployees.timeRecordings.tooltip"
      (btnClick)="openTimeRecording($event)"
    ></base-button>
  </div>
</div>

<ng-template #employeeInfoModalBody>
  <base-customer-employee-info-modal
    [(currentTab)]="currentTab"
    [modalRef]="modalRef"
  ></base-customer-employee-info-modal>
</ng-template>

<ng-template #addSignSelectionPopup>
  <base-sign-contract-selection
    [modalRef]="addSignModalRef"
    [(signingType)]="signingType"
    [currentAssignment]="customerAssignment"
    (signingTypeChange)="onSignTypeChange($event)"
  ></base-sign-contract-selection>
</ng-template>

<ng-template #addSignPopup>
  <base-sign-contracts-sign [modalRef]="digitalSignModalRef"></base-sign-contracts-sign>
</ng-template>

<ng-template #signStatusTooltip>
  <base-sign-contract-status-tooltip
    [contract]="assignmentListItem.contract"
    [isPsp]="false"
  ></base-sign-contract-status-tooltip>
</ng-template>
